export default {
  name: "HeroSection",

  data() {
    return ({
      statusMessage: "Aspirational impact systems online",
      previewTitle: "Aspirational Performance Preview",
      heroContent: {
        eyebrow: "Outcome Intelligence",
        headlinePrefix: "Master Your",
        headlineAccent: "'Visible Impact'",
        headlineSuffix: "Lifecycle.",
        description:
          "From formalizing needs to documenting proven outcomes, AICampus provides the unified pre-login dashboard to focus primary accounts, integrate collaboration, and demonstrate value.",
        primaryCta: "Request a Demo \u2197",
        secondaryCta: "Explore Platform \u2197",
        primaryLink: "/login",
        secondaryLink: "/login",
      },
      milestones: [
        { label: "Initial Contact", value: 70 },
        { label: "Need Definition", value: 60 },
        { label: "Proposal", value: 50 },
        { label: "Agreement", value: 35 },
      ],
      templates: [
        "Success Template",
        "Outcome Summary",
        "Strategic Report Template",
      ],
    });
  },
};
